import { Box, Button, Center, Icon, Input } from '@chakra-ui/react'
import { ArrowUpToLine } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Controller, FieldValues, Path } from 'react-hook-form'

import { ImageContainer } from '../../displayers/ImageContainer'
import { Inputs } from './models'

interface MyProps<T extends FieldValues, K extends Path<T>>
  extends Inputs.InputData<T, K> {
  callback?: () => void
}

export default function <T extends FieldValues, K extends Path<T>>(
  props: MyProps<T, K>,
) {
  const {
    useForm: { control },
    useFormField,
    callback,
  } = props

  return (
    <Controller
      control={control}
      name={useFormField}
      render={({ field: { onChange, value } }) => {
        const [imgStr, setImgStr] = useState<string | ArrayBuffer | null>()

        useEffect(() => {
          if (value === undefined) {
            setImgStr(undefined)
            return
          }

          try {
            if (typeof value === 'string') {
              // loading image
              setImgStr(value)
            } else {
              // sending an image
              const reader = new FileReader()
              reader.onloadend = () => setImgStr(reader.result)
              reader.readAsDataURL(value)
            }
          } catch (error) {
            // console.log('error setting image input');
          }
        }, [value])

        return (
          <Box>
            <Center flexDir="column">
              <ImageContainer src={imgStr ? String(imgStr) : undefined} />

              <Button
                as="label"
                htmlFor={useFormField}
                cursor="pointer"
                mt={4}
                leftIcon={<Icon as={ArrowUpToLine} strokeWidth={1} />}
              >
                Enviar imagem
              </Button>
            </Center>

            <Input
              id={useFormField}
              value={value?.fileName}
              style={{ display: 'none' }}
              onChange={(event) => {
                if (event.target.files) {
                  const file = event.target.files[0]
                  onChange(file)
                  if (callback) callback()
                }
              }}
              type="file"
              accept="image/*"
            />
          </Box>
        )
      }}
    />
  )
}
